module.exports = __webpack_public_path__ + "static/media/lucas-6.jpeg";